import React, { useState, useRef } from "react";
import KeyboardArrowLeftRoundedIcon from "@mui/icons-material/KeyboardArrowLeftRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import DoneRoundedIcon from "@mui/icons-material/DoneRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import RugAPI from "../api/rug";
import { useHistory } from "react-router-dom";
import Snackbar from "@material-ui/core/Snackbar";

function Inshu(props) {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const isMobile = useMediaQuery("(max-width: 1000px)");
  const [info, setInfo] = useState({});
  const [imageUrl, setImageUrl] = useState("");
  const [step, setStep] = useState(1);
  const [trackingCode, setTrackingCode] = useState("");
  const [isOpenSnack, setIsOpenSnack] = useState(false);
  const inputRef = useRef();
  const history = useHistory();
  const {
    texts,
    globalState: { themeDirection },
  } = props;

  const onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const readerr = new FileReader();
      readerr.addEventListener("load", () => {
        setImageUrl(readerr.result);
        setInfo({
          ...info,
          image: dataURLtoFile(readerr.result, "corpet.png"),
        });
      });
      readerr.readAsDataURL(e.target.files[0]);
    } else {
      //setImageUri(imgUri);
    }
  };

  function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  const requestReplaceRug = () => {
    const rugAPIObj = new RugAPI();
    let data = new FormData();
    data.append("national_id", info.nationalCode);
    data.append("file", info.image);
    data.append("name", info.name);
    data.append("phone", info.phone);
    data.append("address", info.address);
    data.append("rug_url", info.link);
    rugAPIObj
      .requestForReplaceRug(data)
      .then((res) => {
        setTrackingCode(res.data.code);
        setStep(step + 1);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div
      style={{
        position: "relative",
        backgroundColor: "#fafaf9",
        minHeight: "166vh",
      }}
    >
      <div
        className="header-inshu"
        style={{ filter: isOpenModal ? "blur(10px)" : "none" }}
      >
        <img className="header-background-1" src="./static/img/nava.png" />
        <img className="header-background-2" src="./static/img/insurance.png" />
        <img
          className="header-background-3"
          src="./static/img/replace-carpet.png"
        />

        <div className="logo-inshu">
          <img
            className="headerLogoIcon"
            onClick={() => {
              history.push("/");
            }}
            width={100}
            height={57}
            src="./static/img/ghalichin-logo.svg"
          />
        </div>

        <div className="carpet-container">
          <div
            style={{
              height: 72,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#6e43f1",
              borderBottom: "1px solid #e4e4e4",
              fontSize: 14,
              fontWeight: "bold",
            }}
          >
            {texts.carpet_replacement}
          </div>
          {step == 1 && (
            <div className="input-inshu-container">
              <div>
                <div>
                  <p className="title-inshu">{texts.name_and_lastname}: </p>
                  <input
                    placeholder={texts.name_and_lastname}
                    className="input-inshu"
                    value={info.name}
                    onChange={(e) => setInfo({ ...info, name: e.target.value })}
                  />
                </div>
                <div>
                  <p className="title-inshu"> {texts.national_Code}:</p>
                  <input
                    className="input-inshu"
                    placeholder={texts.national_Code}
                    maxLength={10}
                    value={info.nationalCode}
                    onChange={(e) =>
                      setInfo({ ...info, nationalCode: e.target.value })
                    }
                  />
                </div>
                <div>
                  <p className="title-inshu"> {texts.phoneNumber}:</p>
                  <input
                    placeholder={texts.phoneNumber}
                    className="input-inshu"
                    maxLength={11}
                    value={info.phone}
                    onChange={(e) =>
                      setInfo({ ...info, phone: e.target.value })
                    }
                  />
                </div>
                <div>
                  <p className="title-inshu">{texts.address}:</p>
                  <input
                    placeholder={texts.address}
                    className="input-inshu"
                    value={info.address}
                    onChange={(e) =>
                      setInfo({ ...info, address: e.target.value })
                    }
                  />
                </div>
              </div>
              <div
                className="inshu-image"
                style={{
                  width: isMobile ? "100%" : 362,
                  marginTop: 30,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  background: imageUrl ? `url(${imageUrl})` : "#f7f5fe",
                  height: isMobile ? 200 : "auto",
                }}
              >
                {!imageUrl && <img src="./static/img/picture.svg" />}
              </div>
              <input
                type="file"
                ref={inputRef}
                style={{ display: "none" }}
                accept=".gif,.jpg,.jpeg,.png"
                onChange={onSelectFile}
              />
              <button
                className="btn-inshu"
                onClick={() => inputRef.current.click()}
              >
                <span style={{ margin: 0 }}>
                  {texts.upload_photo_and_video}
                </span>
                <svg
                  style={{ margin: 0 }}
                  width="46"
                  height="45"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g fill="#FFF" fill-rule="nonzero">
                    <path d="M23.496 21.834a.938.938 0 0 0-1.312 0l-2.813 2.72a.937.937 0 1 0 1.294 1.35l1.228-1.192V30a.937.937 0 1 0 1.875 0v-5.24l1.21 1.218a.938.938 0 0 0 1.33 0 .938.938 0 0 0 0-1.331l-2.812-2.813z" />
                    <path d="M28.146 17.813a5.625 5.625 0 0 0-10.63 0 4.687 4.687 0 0 0-2.888 7.753.938.938 0 1 0 1.406-1.191 2.812 2.812 0 0 1 2.11-4.688h.093a.937.937 0 0 0 .937-.75 3.75 3.75 0 0 1 7.35 0c.09.444.485.76.938.75h.056a2.812 2.812 0 0 1 2.11 4.688.937.937 0 0 0 .084 1.331.937.937 0 0 0 1.322-.084 4.688 4.688 0 0 0-2.888-7.81z" />
                  </g>
                </svg>
              </button>
              <button
                className="btn-inshu"
                onClick={() => setIsOpenModal(true)}
              >
                <span>{texts.the_link_of_the_carpet_you_want}</span>
                <span className="m-0">
                  {themeDirection == "ltr" ? (
                    <ChevronRightRoundedIcon
                      color="#fff"
                      style={{ fontSize: 30, marginTop: 5 }}
                    />
                  ) : (
                    <KeyboardArrowLeftRoundedIcon
                      color="#fff"
                      style={{ fontSize: 30, marginTop: 5 }}
                    />
                  )}
                </span>
              </button>
            </div>
          )}
          {step == 2 && (
            <div className="input-inshu-container">
              <div className="d-flex flex-column align-items-start">
                <div className="d-flex my-2">
                  <p className="title-inshu">{texts.name_and_lastname} :</p>
                  <p className="title-inshu" style={{ color: "#5e6777" }}>
                    {info.name}
                  </p>
                </div>
                <div className="d-flex my-2">
                  <p className="title-inshu">{texts.national_Code} :</p>
                  <p className="title-inshu" style={{ color: "#5e6777" }}>
                    {info.nationalCode}
                  </p>
                </div>
                <div className="d-flex my-2">
                  <p className="title-inshu">{texts.Phone_call} :</p>
                  <p className="title-inshu" style={{ color: "#5e6777" }}>
                    {info.phone}
                  </p>
                </div>
                <div className="d-flex my-2">
                  <p className="title-inshu">{texts.address} :</p>
                  <p className="title-inshu" style={{ color: "#5e6777" }}>
                    {info.address}
                  </p>
                </div>
              </div>
              <div
                className="inshu-image"
                style={{
                  width: isMobile ? "100%" : 362,
                  marginTop: 30,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  background: imageUrl ? `url(${imageUrl})` : "#f7f5fe",
                  height: isMobile ? 200 : "auto",
                }}
              >
                {!imageUrl && <img src="./static/img/picture.svg" />}
              </div>

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <DoneRoundedIcon
                  style={{ color: "#06b170", fontSize: "10rem" }}
                />
                <p style={{ color: "#06b170" }}>
                  تبریک <br />
                  سفارش شما با موفقیت ثبت شد
                </p>
              </div>
            </div>
          )}

          {step == 3 && (
            <div className="input-inshu-container">
              <div
                style={{
                  display: "flex",
                  borderRadius: 25,
                  margin: 50,
                  backgroundColor: "#5b32d9",
                  bottom: isMobile ? 62 : 72,
                }}
              >
                <div
                  style={{
                    borderRadius: 25,
                    padding: isMobile ? "10px 25px" : "10px 40px",
                    whiteSpace: "nowrap",
                    backgroundColor: "#5b32d9",
                    color: "#fff",
                    margin: 0,
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  کد پیگیری
                </div>
                <button
                  style={{
                    borderRadius: 25,
                    width: isMobile ? 150 : 300,
                    backgroundColor: "#ffff",
                  }}
                >
                  {trackingCode}
                </button>
              </div>
              <button
                style={{
                  borderRadius: 25,
                  width: 200,
                  backgroundColor: "#06b170",
                  position: "absolute",
                  bottom: -20,
                  right: 0,
                  left: 0,
                  height: 40,
                  color: "#fff",
                }}
                onClick={() => {
                  navigator.clipboard.writeText(trackingCode);
                  setIsOpenSnack(true);
                }}
              >
                کپی کد پیگیری
              </button>
              <Snackbar
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                open={isOpenSnack}
                onClose={() => setIsOpenSnack(false)}
                message="کد پیگیری با موفقیت کپی شد"
                autoHideDuration={3000}
              />
            </div>
          )}
          {step !== 3 && (
            <div
              style={{
                padding: isMobile ? "30px 0" : "30px 86px",
                display: "flex",
                justifyContent: "space-between",
                marginBottom: -50,
              }}
            >
              <button
                style={{
                  width: isMobile ? 130 : 230,
                  height: 45,
                  backgroundColor: "#bbc2ce",
                  borderRadius: 22.5,
                  display: "flex",
                  alignItems: "center",
                  color: "#fff",
                  padding: "0 13px",
                }}
                onClick={() => setStep(step - 1)}
                disabled={step == 1}
              >
                {themeDirection == "ltr" ? (
                  <KeyboardArrowLeftRoundedIcon
                    className="m-0"
                    color="#fff"
                    style={{ fontSize: 30 }}
                  />
                ) : (
                  <ChevronRightRoundedIcon
                    className="m-0"
                    color="#fff"
                    style={{ fontSize: 30 }}
                  />
                )}

                <span>{texts.coming_back}</span>
              </button>
              <button
                style={{
                  width: isMobile ? 130 : 230,
                  height: 45,
                  backgroundColor:
                    step == 1 &&
                    (!info.name ||
                      !info.phone ||
                      !info.nationalCode ||
                      !info.address ||
                      !info.image ||
                      !info.link)
                      ? "#bbc2ce"
                      : "#06b170",
                  borderRadius: 22.5,
                  display: "flex",
                  alignItems: "center",
                  color: "#fff",
                  padding: "0 13px",
                }}
                disabled={
                  step == 1 &&
                  (!info.name ||
                    !info.phone ||
                    !info.nationalCode ||
                    !info.address ||
                    !info.image ||
                    !info.link)
                }
                onClick={() =>
                  step == 1 ? requestReplaceRug() : setStep(step + 1)
                }
              >
                <span>{texts.confirmation_and_approval}</span>
                {themeDirection == "ltr" ? (
                  <ChevronRightRoundedIcon
                    className="m-0"
                    color="#fff"
                    style={{ fontSize: 30 }}
                  />
                ) : (
                  <KeyboardArrowLeftRoundedIcon
                    color="#fff"
                    className="m-0"
                    style={{ fontSize: 30 }}
                  />
                )}
              </button>
            </div>
          )}
        </div>
      </div>
      {isOpenModal && (
        <div
          className="d-flex justify-contnet-center align-items-center"
          style={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgb(4 4 4 / 40%)",
            zIndex: 1,
          }}
        >
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              width: isMobile ? "90%" : "50%",
              height: "198px",
              backgroundColor: "#fff",
              borderRadius: 15,
              zIndex: 10,
              position: "relative",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 16,
                left: 16,
                color: "gray",
                cursor: "pointer",
              }}
              onClick={() => setIsOpenModal(false)}
            >
              <CloseRoundedIcon />
            </div>

            <div className="p-5" style={{ width: "100%" }}>
              <p className="title-inshu">{texts.photoـorـvideoـlink}</p>
              <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  flexDirection: isMobile ? "column" : "row",
                }}
              >
                <input
                  placeholder={texts.photoـorـvideoـlink}
                  className="input-inshu"
                  value={info.link}
                  onChange={(e) => setInfo({ ...info, link: e.target.value })}
                />
                <button
                  style={{
                    width: isMobile ? "100%" : 230,
                    height: 45,
                    backgroundColor: "#6e43f1",
                    borderRadius: 22.5,
                    display: "flex",
                    alignItems: "center",
                    color: "#fff",
                    padding: "0 13px",
                    margin: isMobile ? 20 : 0,
                    marginRight: isMobile ? 0 : 51,
                  }}
                  onClick={() => setIsOpenModal(false)}
                >
                  <span>{texts.confirmation_and_approval}</span>
                  {themeDirection == "ltr" ? (
                    <ChevronRightRoundedIcon
                      color="#fff"
                      className="m-0"
                      style={{ fontSize: 30 }}
                    />
                  ) : (
                    <KeyboardArrowLeftRoundedIcon
                      color="#fff"
                      className="m-0"
                      style={{ fontSize: 30 }}
                    />
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Inshu;
